export default "__VITE_ASSET__Y8rIE3Rl__"